import { render, staticRenderFns } from "./PopList.vue?vue&type=template&id=fce50fa0&scoped=true&"
import script from "./PopList.vue?vue&type=script&lang=js&"
export * from "./PopList.vue?vue&type=script&lang=js&"
import style0 from "./PopList.vue?vue&type=style&index=0&id=fce50fa0&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fce50fa0",
  null
  
)

export default component.exports